<template>
  <div class="body-container learn-container border-container">
    <div class="select-scroll">
      <div id="main">
        <p class="text-center" v-translate:ACTIVITY_TAB_SCHEDULES_INFO="lang">
          To start an activity, select from the list below.
        </p>
        <div class="progress_container">
          <!-- progress start -->
          <div class="progressbar-box">
            <div class="row activity-progress-row">
              <div class="col-2 col-md-2 text-center pr-0 text-white text-capitalize">
                <label>{{ calender.date | dateFormat("MMM DD") }}</label>
              </div>
              <div class="col-8 col-md-8">
                <div class="progress">
                  <div class="progress-bar" role="progressbar" :style="{ width: progressBarPercentage + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
              <div class="col-2 col-md-2 text-center calender-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                  <path fill="#fff" d="M5.46 16.66h3.5c.336 0 .588-.252.588-.588v-2.436c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.252.588.588.588z" />
                  <path
                    fill="#fff"
                    d="M24.5 4.004h-1.96v1.764c0 1.232-1.008 2.24-2.24 2.24h-1.568c-1.232 0-2.24-1.008-2.24-2.24V4.004h-4.956v1.764c0 1.232-1.008 2.24-2.24 2.24H7.728c-1.232 0-2.24-1.008-2.24-2.24V4.004h-1.96c-1.54 0-2.8 1.26-2.8 2.8v16.884c0 1.54 1.26 2.8 2.8 2.8h21c1.54 0 2.8-1.26 2.8-2.8V6.804c-.028-1.54-1.288-2.8-2.828-2.8zm.924 19.684c0 .504-.42.924-.924.924h-21c-.504 0-.924-.42-.924-.924V10.752h22.876v12.936h-.028z"
                  />
                  <path
                    fill="#fff"
                    d="M12.264 16.66h3.5c.336 0 .588-.252.588-.588v-2.436c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.252.588.588.588zM19.04 16.66h3.5c.336 0 .588-.252.588-.588v-2.436c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.28.588.588.588zM5.46 22.344h3.5c.336 0 .588-.252.588-.588V19.32c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.252.588.588.588zM12.264 22.344h3.5c.336 0 .588-.252.588-.588V19.32c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.252.588.588.588zM19.04 22.344h3.5c.336 0 .588-.252.588-.588V19.32c0-.336-.252-.588-.588-.588h-3.5c-.336 0-.588.252-.588.588v2.436c0 .308.28.588.588.588zM7.728 6.58h1.54c.448 0 .812-.364.812-.812V2.324c0-.448-.364-.812-.812-.812h-1.54c-.448 0-.812.364-.812.812v3.444c-.028.448.336.812.812.812zM18.732 6.58h1.54c.448 0 .812-.364.812-.812V2.324c0-.448-.364-.812-.812-.812h-1.54c-.448 0-.812.364-.812.812v3.444c0 .448.364.812.812.812z"
                  />
                </svg>
                <datepicker class="calendar_btn" input-class=" datepicker-class form-control inner-card-value" name="startDate" :language="calenderLang" v-model="calender.date" @closed="getActivityList" placeholder="enter your date"> </datepicker>
              </div>
            </div>
          </div>
          <!-- progress end -->
        </div>
        <div class="activity1-container activity-section border-container " id="faq" v-if="activities && activities.length > 0">
          <div class="card faq-card" v-for="(activity, index) in activities" :key="index">
            <div class="card-header faqhead3 text-center">
              <a @click="goToDetails(activity)" class="btn btn-header-link">
                <img v-if="activity.allowMultiple" class="mr-10" src="static/img/participant-portal/refresh.png" />

                <span
                  v-translate:dynamic_string="{
                    key: `${activity.taskId}_taskTitle`,
                    val: lang,
                    html: activity.taskTitle
                  }"
                  v-html="$sanitize(activity.taskTitle)"
                ></span>
                <span v-if="activity.allowMultiple && activity.completedCount > 0" class="float-right">
                  <svg class="check_icon d-block" xmlns="http://www.w3.org/2000/svg" width="22" height="17" fill="none" viewBox="0 0 22 17">
                    <path fill="#B8E986" fill-rule="evenodd" d="M19.598.103l-12.63 12.69L2.3 8.103c-.275-.275-.55-.275-.824 0L.103 9.483c-.137.276-.137.69 0 .827l6.452 6.483c.275.276.55.276.824 0L21.794 2.31c.275-.276.275-.551 0-.827L20.421.103c-.274-.137-.686-.137-.823 0z" clip-rule="evenodd" />
                  </svg>
                  <span class="n-times" v-if="activity.completedCount > 0">{{ Number(activity.completedCount) }}</span
                  >&nbsp;<span class="n-times" v-if="activity.completedCount > 0" v-translate:times_key="lang">times</span>
                </span>
                <span v-else class="float-right">
                  <svg v-if="activity.allowMultiple == false && activity.completedCount == 1" class="check_icon d-block" xmlns="http://www.w3.org/2000/svg" width="22" height="17" fill="none" viewBox="0 0 22 17">
                    <path fill="#B8E986" fill-rule="evenodd" d="M19.598.103l-12.63 12.69L2.3 8.103c-.275-.275-.55-.275-.824 0L.103 9.483c-.137.276-.137.69 0 .827l6.452 6.483c.275.276.55.276.824 0L21.794 2.31c.275-.276.275-.551 0-.827L20.421.103c-.274-.137-.686-.137-.823 0z" clip-rule="evenodd" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 27 27">
                    <circle cx="13.5" cy="13.5" r="12.5" fill="#fff" stroke="#B8E986" stroke-width="2" />
                    <path fill="#B8E986" fill-rule="evenodd" d="M9.913 19.913L12 22l8-8-8-8-2.087 2.087L15.826 14l-5.913 5.913z" clip-rule="evenodd" />
                  </svg>
                  <span class="n-times"></span>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="container" v-else-if="loading === false">
          <div class="card faq-card">
            <div class="card-header faqhead3 text-center">
              <a class="btn btn-header-link">
                <p class="text-center" v-translate:rss_activities_empty_message="lang">
                  No available activities at this moment
                </p>
              </a>
            </div>
          </div>
        </div>
        <update-version />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import * as calenderLanguage from "vuejs-datepicker/dist/locale";
import { mapGetters, mapActions } from "vuex";
import localStorageService from "@/services/localStorage";
import { Bitrise, Graph, Activities, Widget, ParticipantPortal } from "@/components/services/participant-service";
import swal from "sweetalert2";
import UpdateVersion from "@/components/participant-portal/update-version";
import * as webSocketService from "@/services/webSocket";

export default {
  name: "activity-list",
  props: ["studyId", "languageId", "globalElement"],
  data() {
    return {
      taskSchedules: [],
      calenderLang: calenderLanguage.en,
      widget: new Widget(),
      graph: new Graph(),
      portal: new ParticipantPortal(),
      supportedTaskTypes: ["survey", "epro", "telehealth"],
      disabledDate: {
        to: moment()
          .subtract(1, "days")
          .toDate()
      },
      bitrise: new Bitrise(),
      loading: true,
      adherences: [],
      activities: [],
      areActivityDisabled: false,
      scheduledActivities: [],
      participantData: "",
      studyVersionId: null,
      checkManualStudyStartData: null,
      learnn: "",
      startDay: 0,
      endDay: 1,
      calender: {
        date: new Date()
      },
      activityObject: {}
    };
  },
  components: {
    Datepicker,
    UpdateVersion
  },
  computed: {
    ...mapGetters(["participant", "token", "getWebSocketServiceData"]),
    userStartDate() {
      const date = new Date();
      if (this.participant && (this.participant.startDate || this.participant.registrationDate)) {
        if (this.participant.startDate == 0) {
          return moment(new Date(this.participant.registrationDate), "YYYY-MM-DD");
        } else {
          return moment(new Date(this.participant.startDate), "YYYY-MM-DD");
        }
      } else {
        return moment(date, "YYYY-MM-DD");
      }
    },
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    progressBarPercentage() {
      let completed = 0;
      if (this.activities.length) {
        this.activities.forEach(element => {
          if (element.completedCount > 0 && !element.activityIsOptional) {
            completed++;
          }
        });
        return parseInt((completed / this.activities.length) * 100);
      } else {
        return 0;
      }
    }
  },
  watch: {
    getWebSocketServiceData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.messageCount) {
          this.getFilterActivity();
        }
      }
    }
  },
  mounted() {
    if (this.study != null) {
      this.loading = true;
      const calLang = this.widget.getCalendarLanguageAvailable();
      this.calenderLang = calenderLanguage[calLang];
      this.getStrings();
      navigator.serviceWorker.addEventListener("message", event => {
        if (event.data.type == "manualStudyStartDay") {
          this.checkForManualStudyStart();
        }
        if (event.data.type == "dynamicAddActivity") {
          this.getAdheranceData();
        }
      });
      if (this.study.isManualStudyStart) {
        this.checkForManualStudyStart();
      } else {
        this.getAdheranceData();
      }
    }
  },
  created() {
    if (this.study != null) {
      this.widget.getActivityTranslation(this.study, this.lang).then(() => {});
    }
  },
  methods: {
    createSocket() {
      const params = {
        id: this.participant.pid,
        clientId: localStorageService.getItem("clientId"),
        participantId: this.participant.pid,
        studyId: this.studyId,
        languageId: this.participant.languageId,
        studyVerId: this.participant.myStudyVersionId
      };
      if (!this.getWebSocketServiceData) {
        webSocketService.setSocketConnection(params);
      }
    },
    ...mapActions(["setParticipantAdherences", "setParticipantTaskSchedules", "setParticipantStudyTaskSchedules"]),
    afterActivityLoaded() {
      this.$root.$emit("activities-loaded");
    },
    checkForManualStudyStart() {
      this.$api
        .getParticipantManualStudyStartStatus(this.participant.pid, {
          studyId: this.studyId
        })
        .then(res => {
          this.checkManualStudyStartData = res.data;
          this.$store.dispatch("saveParticipantStudyStartStatus", res.data);
          if (res.data.isConfirmed) {
            this.getAdheranceData();
          } else if (res.data.isPiConfirmed) {
            this.loading = false;
            swal({
              title: this.widget.translate("study_start_confirmation_message", "Your study has begun."),
              type: "info",
              icon: false,
              iconHtml: "<p></p>",
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              showCancelButton: false,
              okButtonText: this.widget.translate("OK_BUTTON_TITLE", "OK")
            }).then(({ value }) => {
              if (value) {
                const now = new Date();
                const payload = {
                  confirmedOnLocal: moment(now).format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
                  confirmedTimeOffset: moment(now).format("Z"),
                  isConfirmed: true,
                  timezone: moment.tz.guess()
                };
                this.$api.confirmParticipant(this.participant.pid, this.studyId, payload).then(() => {
                  this.checkManualStudyStartData.isConfirmed = true;
                  this.$store.dispatch("saveParticipantStudyStartStatus", this.checkManualStudyStartData);
                  this.getAdheranceData();
                });
              }
            });
            document.querySelectorAll(".swal2-icon").forEach(item => (item.style.display = "none"));
          } else {
            this.loading = false;
          }
        });
    },
    getAdheranceData() {
      this.$api
        .getParticipantAdharance({
          participantId: this.participant.pid,
          studyId: this.studyId
        })
        .then(response => {
          this.adherences = response.data.results;
          this.setParticipantAdherences(response.data.results);
          this.getFilterActivity();
        })
        .catch(() => {
          this.loading = false;
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    getStrings() {
      const lang = this.lang === "en" ? "EN" : this.lang;
      const language = lang.includes("-") ? lang : lang.toUpperCase();
      const stringObj = this.bitrise.getJsonData(language + "-strings");
      if (stringObj) {
        stringObj
          .then(response => {
            this.$store.dispatch("setParticipantsPortalStrings", response);
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      }
    },
    goToDetails(activity) {
      if (this.areActivityDisabled) {
        this.$toastr.error(this.widget.translate("completed_activity_error_meassege", "This activity has either been completed or is no longer available."));
        return false;
      }
      if (activity.taskType && !this.supportedTaskTypes.includes(activity.taskType)) {
        const message = this.widget.translate("activity_not_supported", "Task not supported.");
        this.$toastr.error(message);
        return;
      }
      if (activity.completedCount == undefined) {
        activity.completedCount = 0;
      }
      if (activity.allowMultiple || (activity.allowMultiple == false && activity.completedCount == 0)) {
        let selectedActivity = this.adherences.find(o => o.taskId == activity.taskId);
        const selectedSchedules = this.taskSchedules.filter(o => o.taskId == activity.taskId);
        const selectedSchedule = selectedSchedules.find(o => o.startDay <= this.portal.getCurrentDay() && o.endDay >= this.portal.getCurrentDay());
        if (selectedActivity == undefined) {
          selectedActivity = {
            completedCount: 0,
            participantId: this.participant.pid,
            scheduledCount: this.endDay,
            siteId: null,
            siteName: null,
            studyId: this.studyId,
            taskId: activity.taskId,
            taskName: activity.taskTitle,
            taskTitle: activity.taskTitle,
            taskType: activity.taskType
          };
        }
        this.$store.dispatch("setParticipantSelectedActivity", Object.assign(selectedActivity, selectedSchedule));
        /** Handle Telehealth Redirection */
        if (activity.taskType == "telehealth") {
          this.$router.push({
            name: "participants-portal-activity-telehealth-details",
            params: {
              studyId: this.$route.params.studyId,
              taskId: activity.taskId,
              activity: activity
            }
          });
          return;
        }
        /** Handle Telehealth Redirection */
        this.$router.push({
          name: "participants-portal-activity-details",
          params: {
            taskType: activity.taskType,
            taskId: activity.taskId,
            taskInstanceId: activity.taskInstanceId
          }
        });
      } else {
        const message = this.widget.translate("PWE_SUCCESS_ACTIVITY_ALREADY_SUBMIT", "Activity has been submitted already.");
        this.$toastr.error(message);
      }
    },
    getActivityListData(tasksListOld, startDay) {
      let tasksList = tasksListOld;
      let bitScheduleObj;
      const tasksAndSchedules = this.bitrise.getJsonData("tasks_and_schedules");
      if (tasksAndSchedules) {
        tasksAndSchedules.then(response => {
          bitScheduleObj = response.schedules;
          const scheduledCurrentVersionTaskIds = bitScheduleObj.map(it => it.tasks[0].taskID);
          tasksList = tasksList.filter(it => scheduledCurrentVersionTaskIds.indexOf(it.taskId) > -1);
          this.setParticipantStudyTaskSchedules(response.schedules);
          const taskIdList = tasksList.map(o => o.taskId);
          // Need to remove duplicate before get scheduledCount
          const uniqueTaskIdList = taskIdList.filter((item, index) => {
              return taskIdList.indexOf(item) === index;
          });
          const scheduleObj = bitScheduleObj;
          const postData = {
            taskIdList: uniqueTaskIdList,
            schedule: { schedules: scheduleObj }
          };

          this.$api
            .getPortalDashboardData(this.participant.pid, this.studyId, startDay, { participantId: this.participant.pid, web: true }, postData)
            .then(response => {
              const activityDataList = response.data;
              const activityDataMap = activityDataList.map(o => o.taskId);
              const that = {
                activityDataMap: activityDataMap,
                activityDataList: activityDataList
              };
              tasksList = tasksList.map(o => {
                if (that.activityDataMap.includes(o.taskId)) {
                  const thisTask = that.activityDataList.find(i => i.taskId == o.taskId && i.taskInstanceId == o.taskInstanceId);
                  const schedule = scheduleObj.find(j => j.scheduleId == o.scheduleId);
                  o.displayOrder = schedule ? schedule.displayOrder : 0;
                  if (thisTask) {
                    o.completedCount = thisTask.completedCount > o.completedCount ? thisTask.completedCount : o.completedCount;
                    o.scheduledCount = thisTask.scheduledCount;
                  }
                  
                  o.activityOptional = !!(schedule && schedule.tasks[0] && schedule.tasks[0].isActivityOptional);
                }
                return o;
              }, that);
              this.activities = tasksList.sort((a, b) => {
                return a.displayOrder - b.displayOrder;
              });
              this.afterActivityLoaded();
            })
            .catch(() => {
              this.loading = false;
              const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
              if (message) {
                this.$toastr.error(message);
              }
            });
        });
      }
    },
    getFilterActivity(date = null) {
      const message = this.widget.translate("dashboard_no_activities_for_today", "No activities for today");
      const selectedDate = date === null ? this.calender.date : date;
      this.activities = [];
      const startDay = this.portal.getDayFromDate(selectedDate);
      this.startDay = startDay;
      const endDay = startDay;
      this.endDay = endDay == 0 ? 1 : endDay;
      this.areActivityDisabled = !this.portal.isCalendarDateToday(selectedDate);
      if (Object.keys(this.participant).length > 0 && this.participant.pid !== "" && startDay >= 0) {
        this.$api
          .getParticipantsScheduledActivities(this.participant.pid, this.participant.myStudyVersionId, { studyId: this.studyId, startDay: startDay, endDay: startDay })
          .then(response => {
            const scheduledTasks = response.data.participantTaskSchedules;
            if (!scheduledTasks || (Array.isArray(scheduledTasks) && scheduledTasks.length === 0)) {
              this.loading = false;
              this.$toastr.info(message);
              return false;
            }
            const adherences = response.data.participantTaskAdherence;
            const adherenceExtra = this.adherences.map(o => {
              return {
                taskId: o.taskId,
                studyId: o.studyId,
                studyVersionId: o.studyVersionId,
                deviceId: o.deviceId
              };
            });
            const adherenceTaskIds = adherences.map(o => {
              const taskExtra = adherenceExtra.find(i => i.taskId == o.taskId);
              return taskExtra ? Object.assign(o, taskExtra) : o;
            });
            this.setParticipantTaskSchedules(response.data.participantTaskSchedules);
            this.taskSchedules = scheduledTasks.filter(o => this.startDay <= o.endDay);
            this.activityObject = new Activities(adherenceTaskIds, response.data.participantTaskSchedules);

            const activityData = this.activityObject.getScheduledActivitiesByInstance(this.calender.date);
            const tasksList = [];
            activityData.forEach(data => {
              if (data.taskTitle !== "" && data.taskTitle !== null && data.taskTitle !== undefined) {
                tasksList.push(data);
              }
            });
            this.getActivityListData(tasksList, startDay);
            this.loading = false;
            this.createSocket();
          })
          .catch(e => {
            this.loading = false;
            this.$toastr.error(e.message ? e.message : message);
          });
      } else {
        this.activities = [];
      }
    },
    getActivityList() {
      if (this.study.isManualStudyStart) {
        this.checkForManualStudyStart();
      } else {
        this.getAdheranceData();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}

.progressbar-box {
  height: auto;
  background: var(--primary);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.inner-container {
  margin: 5% 15%;
}
.faqhead3 .fa-refresh {
  color: #b0bac9;
  font-size: 20px;
}
.faqhead3 .fa-check {
  color: #b8e986;
  font-size: 24px;
}
.faqhead3 .n-times {
  color: #b8e986;
  font-size: 11px;
}
.activity-progress-row {
  padding: 13px 0 10px 0;
}

.calender-icon {
  margin-top: -5px;
}
.progress {
  border: solid 1px var(--secondary);
  background-color: #f3f3f3;
  height: 12px;
  margin-top: 5px;
  border-radius: 10px;
}
.progress-bar {
  background-color: var(--secondary);
}
.select-scroll {
  height: calc(100vh - 160px);
  overflow-y: auto;
}
</style>
